export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? "http://127.0.0.1:8000";

export type ApiError = Error & { status?: number };

export function getAccessToken() {
  return localStorage.getItem("accessToken");
}

export async function authorizedRequest(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const token = getAccessToken();
  if (!token) {
    const err: ApiError = new Error("Not authenticated.");
    err.status = 401;
    throw err;
  }

  const headers = {
    Authorization: `Bearer ${token}`,
    ...(options.headers || {}),
  } as Record<string, string>;

  return fetch(url, {
    ...options,
    headers,
  });
}

export async function parseResponse<T>(response: Response): Promise<T> {
  let data: unknown = {};
  try {
    data = await response.json();
  } catch {
    data = {};
  }

  if (!response.ok) {
    const message =
      (typeof (data as { detail?: string })?.detail === "string" &&
        (data as { detail?: string }).detail) ||
      "Request failed.";
    const err: ApiError = new Error(message);
    err.status = response.status;
    throw err;
  }

  return data as T;
}

